<section class="main">
    <h1>Add Inovice</h1>
    <hr>
    <form class="example-form">
        <mat-form-field class="example-full-width">
            <mat-label>Serch Unit</mat-label>
            <input type="text" (input)="getData($event)" placeholder="Unit Name" matInput [formControl]="myControl"
                [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)='getOption($event.option.value)'
                [displayWith]="displayFn">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                    {{option.name}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <div >
            <label>
                    consumed
            </label>
            <input [(ngModel)]="consumed" [ngModelOptions]="{standalone: true}" type="number" class="form-control">
        </div>
        <div class="mt-3">
                <label>
                        Description
                </label>
                <textarea [(ngModel)]="description" [ngModelOptions]="{standalone: true}" type="text" class="form-control"></textarea>
        </div>
    </form>
    <div class="submitBtn">
        <button class="btn" (click)="addInovce()">Add Inovice</button>
    </div>
</section>